import { all } from "redux-saga/effects";
import acquiredPropertiesSaga from "ducks/acquiredProperties/sagas";
import acquiredVehiclesSaga from "ducks/acquiredVehicles/sagas";
import businessCompleteSolutionSagas from "ducks/businessCompleteSolution/sagas";
import creditCardSaga from "ducks/creditCards/sagas";
import depositRatesSaga from "ducks/depositRates/sagas";
import investmentSaga from "ducks/investment/sagas";
import dxpLanding from "ducks/dxpLanding/sagas";
import homeLoanRatesSaga from "ducks/homeLoanRates/sagas";
import homePageSaga from "ducks/homePage/sagas";
import navigationAndFooterSaga from "ducks/navigationAndFooter/sagas";
import personalLoanRatesSaga from "ducks/personalLoanRates/sagas";
import requestForCallbackSagas from "ducks/requestForCallback/sagas";
import timeDepositRatesSaga from "ducks/timeDepositRates/sagas";
import topBondPicksSaga from "ducks/topBondPicks/sagas";
import ewBillersSaga from "ducks/otherServices/sagas";

const rootSagas = [
  acquiredPropertiesSaga(),
  acquiredVehiclesSaga(),
  businessCompleteSolutionSagas(),
  creditCardSaga(),
  depositRatesSaga(),
  investmentSaga(),
  dxpLanding(),
  homeLoanRatesSaga(),
  homePageSaga(),
  navigationAndFooterSaga(),
  personalLoanRatesSaga(),
  requestForCallbackSagas(),
  timeDepositRatesSaga(),
  topBondPicksSaga(),
  ewBillersSaga(),
];

export default function* rootSaga() {
  yield all(rootSagas);
}
